import { CheckCircleIcon } from '@heroicons/react/24/solid';
import { Link } from 'react-router-dom'; // 1. Import Link

export default function GuestBenefits() {
  const brandColor = '#e46809';

  return (
    <div className="p-4 rounded-lg bg-orange-50 dark:bg-orange-900/50 border-l-4" style={{ borderColor: brandColor }}>
      <h3 className="font-bold text-gray-800 dark:text-white">Sign up to unlock benefits!</h3>
      <ul className="mt-2 space-y-1 text-sm text-gray-600 dark:text-gray-300">
        <li className="flex items-center"><CheckCircleIcon className="w-5 h-5 mr-2 flex-shrink-0" style={{ color: brandColor }} />Track the status of your gift.</li>
        <li className="flex items-center"><CheckCircleIcon className="w-5 h-5 mr-2 flex-shrink-0" style={{ color: brandColor }} />Receive a personal thank-you video from the recipient.</li>
        <li className="flex items-center"><CheckCircleIcon className="w-5 h-5 mr-2 flex-shrink-0" style={{ color: brandColor }} />View your complete gifting history.</li>
      </ul>
      
      {/* 2. ADD THE NEW SIGN UP LINK */}
      <div className="mt-3">
        <Link 
          to="/login"
          state={{ defaultTab: 'signup', defaultRole: 'donor' }}
          className="font-bold text-sm hover:underline" 
          style={{ color: brandColor }}
        >
          Create an account now &rarr;
        </Link>
      </div>
    </div>
  );
}